<template>
  <tr class="bold white">
    <td class="font-size-0875-rem font-weight-bold text-no-wrap text-left">{{ title }}</td>
    <td
      v-for="summary, index in summaryList"
      :key="index"
      class="px-2 font-size-0875-rem font-weight-bold text-right"
    >
      {{ summary }}
    </td>
    <td class="px-2 font-size-0875-rem font-weight-bold text-right">{{ summaryTotal }}</td>
  </tr>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue"

export default defineComponent({
  name: "YearlySummaryTotalRow",
  props: {
    rowTitle: {
      type: String,
      required: true
    },
    summaryList: {
      type: Array,
      required: true
    },
    summaryTotal: {
      type: [Number, String],
      required: true
    },
  },
  setup(props) {
    const title = computed(() => props.rowTitle as string)
    const summaryList = computed(() => props.summaryList as Array<string>)
    const summaryTotal = computed(() => props.summaryTotal as number | string)

    return {
      title,
      summaryList,
      summaryTotal
    }
  }
})
</script>
